import type { Requests } from "../common/request.common";
import type { NotificationResponseTypes } from "../common/response.common";
import { get, post } from "./common";

export const notification = {
    latest() {
        return get<NotificationResponseTypes.Latest>(`/notification/latest`);
    },
    unread() {
        return get<NotificationResponseTypes.Unread>(`/notification/unread`);
    },
    update(id: string, data: typeof Requests.Notification.Update.Input) {
        return post<typeof data, NotificationResponseTypes.Update>(
            `/notification/update/${id}`,
            data,
        );
    },
    sendCustomer(data: typeof Requests.Notification.SendCustomer.Input) {
        return post<typeof data>(`/notification/send-customer`, data);
    },
};
